import { render } from "./AddOrganization.vue?vue&type=template&id=1a56cd87"
import script from "./AddOrganization.vue?vue&type=script&lang=js"
export * from "./AddOrganization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__